import googleTranslate from '@/lib/google-translate/googleTranslate.js'

export const generateAiCategoryImage = async (item) => {
  const name = getTranslatedField(item, 'Name')
  const desc = getTranslatedField(item, 'Description')
  const trans = await googleTranslate([name || '', desc || ''], 'en-US')
  const itemName = name ? trans[0]?.translatedText : ''
  const itemDesc = desc ? trans[1]?.translatedText : ''
  const prompt = `A photorealistic, realistic, beautiful, restaurant menu category: ${itemName}. ${itemDesc} Professional food photography, restaurant menu style, high detail, vibrant colors, no text, no watermark, no people, only the image on a clean background, studio lighting, shallow depth of field.`

  return itemName ? await text2Image(prompt, {width: 1536, height: 512}, '@cf/stabilityai/stable-diffusion-xl-base-1.0') : null
}

export const generateAiProductImage = async (item) => {
  const name = getTranslatedField(item, 'Name')
  const desc = getTranslatedField(item, 'Description')
  const category = getTranslatedField(item, 'CategoryName')
  const trans = await googleTranslate([name || '', desc || '', category || ''], 'en-US')
  const itemName = name ? trans[0]?.translatedText : ''
  const itemDesc = desc ? trans[1]?.translatedText : ''
  const itemCategory = category ? trans[2]?.translatedText : ''
  const prompt = `A photorealistic, realistic, beautiful, restaurant menu item: ${itemName}${itemCategory ? ' in menu category ' + itemCategory : ''}. ${itemDesc} Professional food photography, restaurant menu style, high detail, vibrant colors, no text, no watermark, no people, only the image on a clean background, studio lighting, shallow depth of field.`

  return itemName ? await text2Image(prompt, {width: 1024, height: 512}, '@cf/stabilityai/stable-diffusion-xl-base-1.0') : null
}

/**
 *
 * @param prompt {String}
 * @param size {Object<{width: Number, height: Number}>}
 * @param model {String}
 * @returns {Promise<{Blob: Blob, Image: string, Name: string, Filename: string}>}
 */
export const text2Image = async (prompt, size, model) => {
  const apiUrl = 'https://text2image-gen-api.otodevathens.workers.dev'
  const apiKey = 'YB30j9drNu8hrGApKP9xowgE3NBTLzqd'

  if (!model) model = '@cf/stabilityai/stable-diffusion-xl-base-1.0'

  // Choose model from the following list:

  // "@cf/leonardo/lucid-origin"
  // "@cf/leonardo/phoenix-1.0"
  // "@cf/bytedance/stable-diffusion-xl-lightning"
  // "@cf/black-forest-labs/flux-1-schnell"
  // "@cf/runwayml/stable-diffusion-v1-5-img2img"
  // "@cf/lykon/dreamshaper-8-lcm"
  // "@cf/runwayml/stable-diffusion-v1-5-inpainting"
  // "@cf/stabilityai/stable-diffusion-xl-base-1.0"

  const response = await fetch(apiUrl, {
    method : 'POST',
    headers: {
      'Authorization': `Bearer ${apiKey}`,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({prompt: prompt, size: size, model: model})
  })

  if (!response.ok) {
    const result = await response.json()
    console.error(result)
    return null
  } else {
    const blob = await response.blob()
    return {
      Blob    : blob || null,
      Image   : blob ? URL.createObjectURL(blob) : '',
      Name    : '',
      Filename: 'image.jpg'
    }
  }
}

const getTranslatedField = (item, field, LangObjName = 'Lang', fallback = true, fallbackField = '') => {
  const defaultLanguageCode = 'el'
  let retVal = item && field && item[LangObjName] && item[LangObjName][defaultLanguageCode] && item[LangObjName][defaultLanguageCode][field] || ''

  if (!retVal && fallback) {
    fallbackField = fallbackField || field
    retVal = item && fallbackField && item[fallbackField] || item && fallbackField && item[LangObjName] && item[LangObjName][defaultLanguageCode] && item[LangObjName][defaultLanguageCode][fallbackField] || ''
  }
  return retVal
}
